import { getFormattedSubtotal } from '@/components/SunrunShop/utils/price';
import useSunrunShopStore from '@/data-store/zustand/hooks/useSunrunShopStore';
import useGlobalStyles from '@/styles/global.styles';

import useStyles from './Cart.styles';

export default function Subtotal() {
  const { cart } = useSunrunShopStore('cart');
  const { classes, cx } = useStyles();
  const { classes: globalClasses } = useGlobalStyles({ fixed: true });

  const subtotal = getFormattedSubtotal(cart);

  return (
    <h4 className={cx(globalClasses.h4, classes.subtotal)}>
      Subtotal: {subtotal}
    </h4>
  );
}
